import React, { useEffect, useState } from "react";
import { ReactComponent as  Cart } from '../../assets/Cart.svg';
import { ReactComponent as  Profile } from '../../assets/Profile.svg';
import { ReactComponent as  CartSmall } from '../../assets/cart_small.svg';
import { Link, useNavigate } from "react-router-dom";
import ProfileDropdown from './ProfileDropdown';
import { useAppContext } from "../../AppContext";

interface SmallButtonProps {
    type: string;
}

const SmallButton: React.FC<SmallButtonProps> = ({type}) => { 
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const {role,user}=useAppContext();
    const navigate = useNavigate();



    if (type === "cart") {
        return (
            <Link className={`md:h-14 h-12 w-auto flex items-center justify-center px-4 rounded-2xl border border-[#D8DADC]`} 
            to="/shopping-cart">
                <div className="hidden md:block">
                    <Cart />
                </div>
                <div className="block md:hidden">
                    <CartSmall />
                </div>
            </Link>
        );
    }



    return (
        <div className="relative">
            <button 
                className={`md:h-[56px] h-12 w-[56px]  flex items-center justify-center ${role === 'publisher' ? 'px-[0.4rem]' : 'px-4'} rounded-2xl border border-[#D8DADC] p-[0.4rem]`}
                onClick={() => setIsProfileOpen(!isProfileOpen)}
            >
                {role === 'publisher' ? <img src={user?.publisherIconUrl} className="w-full h-full rounded-2xl object-contain" alt="User profile" /> : <Profile />}
            </button>
            <ProfileDropdown isOpen={isProfileOpen} setIsOpen={setIsProfileOpen}/>
        </div>
    );
}

export default SmallButton;